import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Button } from 'reactstrap';
import propTypes from 'prop-types';

const ButtonLoading = props =>{
  const { isLoading, disabled, loadingText, buttonText, children, ...buttonProps } = props;
  return(
    <Button 
      disabled={(isLoading||disabled)}
      {...buttonProps}
    >
      {
        isLoading?
        loadingText
        :
        (children? children: buttonText)
      }
    </Button>
  )
}

export default ButtonLoading;

ButtonLoading.propTypes={
  isLoading:propTypes.bool,
  active:propTypes.bool,
  color:propTypes.string,
  size:propTypes.string,
  disabled:propTypes.bool,
  onClick:propTypes.func,
  loadingText:propTypes.string,
  buttonText:propTypes.string
}

ButtonLoading.defaultProps = {
  size: 'md',
  buttonText: 'SUBMIT',
  loadingText:'SUBMITTING...'
};
  